import { render, staticRenderFns } from "./postLink.vue?vue&type=template&id=564888f2&"
import script from "./postLink.vue?vue&type=script&lang=js&"
export * from "./postLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports